<div class="pie-statistics">
  <div class="pie-statistics__chart" *ngIf="pieChartData.datasets.length > 0">
    <brt-chart (onIndexHover)="onItemChartHovered($event)" (onIndexHoverOut)="onItemChartHoverOut()" [data]="chartData"></brt-chart>
  </div>

  <div class="pie-statistics__data">
    <div class="pie-statistics__item" *ngFor="let item of items; index as idx" [ngClass]="{'highlighted': idx === highlightedItemIdx}">
      <div class="pie-statistics__item-image" *ngIf="item.image"></div>
      <div class="pie-statistics__item-color-dot" *ngIf="item.color && item.color.length > 0" [ngStyle]="{'background-color': item.color}"></div>

      <div class="pie-statistics__item-title">{{item.title}}</div>

      <div class="pie-statistics__item-value-wrapper">
<!--        <div class="pie-statistics__item-value-difference" *ngIf="item.difference !== 0" [ngClass]="[item.difference > 0 ? 'positive' : 'negative']">-->
<!--          <span class="pie-statistics__item-value-difference-arrow-up">↑</span><span class="pie-statistics__item-value-difference-arrow-down">↓</span> {{item.difference| number}}%-->
<!--        </div>-->

        <div class="pie-statistics__item-value">{{item.value}}{{item.valueUnit}}</div>
      </div>
    </div>
  </div>
</div>
